import i18next from 'i18next';
import * as Yup from 'yup';

// Matches: integer (3), floats (3.3 and 3,3) and fraction (3/3)
const validFactorFormat = /^\d+([.,]\d+)?(\/\d+([.,]\d+)?)?$/;

const factorField = Yup.string()
  .required(i18next.t('validation.common.required'))
  .test(
    'valid-factor-format',
    i18next.t('validation.common.noNumber'),
    (value) => !value || validFactorFormat.test(value),
  );

const studentCountField = Yup.number()
  .typeError(i18next.t('validation.common.noNumber'))
  .integer(i18next.t('validation.common.integerOnly'))
  .min(0, i18next.t('validation.common.positiveNumber'))
  .notRequired();

export const factorFormSchema = Yup.object().shape({
  comment: Yup.string(),
  valueRaw: factorField,
  valuePartialRaw: factorField,
  factorType: Yup.string().required(i18next.t('validation.common.required')),
  grades: Yup.array().of(Yup.number().required(i18next.t('validation.common.required'))),
  studentsMin: studentCountField,
  studentsMax: studentCountField,
  studentsPartialMin: studentCountField,
  studentsPartialMax: studentCountField,
});
